import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-user-tasks',
  templateUrl: './view-user-tasks.component.html',
  styleUrls: ['./view-user-tasks.component.css']
})
export class ViewUserTasksComponent implements OnInit {
  snowflakes: { positionX: number, positionY: number, speed: number, opacity: number }[] = [];

  constructor() { }

  ngOnInit(): void {
    this.generateSnowflakes();
  }

  generateSnowflakes(): void {
    setInterval(() => {
      const snowflake = {
        positionX: Math.random() * window.innerWidth, // Случайное положение по X
        positionY: -10, // Начало чуть выше экрана
        speed: Math.random() * 3 + 2, // Скорость падения (2-5 сек)
        opacity: Math.random() * 0.5 + 0.5 // Прозрачность (0.5-1)
      };

      this.snowflakes.push(snowflake);

      // Удаляем снежинку после завершения анимации
      setTimeout(() => {
        this.snowflakes.shift();
      }, 5000); // Длительность анимации падения
    }, 300); // Добавляем снежинки каждые 300 мс
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-user-tasks/view-user-tasks.component.ts